// extracted by mini-css-extract-plugin
export default {"slider":"slider_slider__EHvga","track":"slider_track__Kf8bM","grabber":"slider_grabber__6iE9V"};